import config, { apiEnv } from './config.api';

import axios from 'axios';
import cookies from 'browser-cookies';
import { getService } from '@innovyze/lib_get_service';

const options = {
	baseURL: getService('amInspection', config, apiEnv),
	timeout: 30000,
};

const inspectionService = axios.create(options);

inspectionService.interceptors.request.use(
	config => {
		config.headers.Authorization = 'Bearer ' + cookies.get('auth0.user.token');
		return config;
	},
	error => {
		Promise.reject(error);
	},
);

export default inspectionService;

import { formatUrlTrailing } from '@Utils/urlFormatting';

export const inspectionBaseUrl = formatUrlTrailing(getService('amInspection', config, apiEnv));
